import { Button, Select } from "antd";
import CommonInputField from "./common_input_field";
import DeleteIcon from "./DeleteIcon";
import NavigationButton from "./navigation_button";
import { PlusOutlined } from "@ant-design/icons";
import { useMemo } from "react";


interface Link {
  platform: string;
  url: string;
  icon: React.ReactNode;
}

interface SocialPlatform {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface MultipleInputComponentProps {
  links: Link[];
  setLinks: (links: Link[]) => void;
  socialPlatforms: SocialPlatform[];
  title: string;
  field: string;
  commonIcon?: React.ReactNode;
}

const MultipleInputComponent: React.FC<MultipleInputComponentProps> = ({ links, setLinks, socialPlatforms, title, field, commonIcon }) => {
  const handleChange = (index: number, field: string, value: string) => {
    const updatedLinks = [...links];
    if (field === "platform" || field === "url") {
      updatedLinks[index][field as keyof Link] = value;
    }
    setLinks(updatedLinks);
  };

  const handleDelete = (index: number) => {
    setLinks(links.filter((_, i) => i !== index));
  };

  const addNewLink = () => {
    setLinks([...links, { platform: "", url: "",icon:undefined  }]);
  };

   const marketplacePlatforms = useMemo(() => {
      return links?.map((m: any) => m?.platform)
    }, [links])

  return (
    <div className="space-y-4">
      <div>
        <div className="common-title text-[#1d2939] text-base pb-[14px]">
          {title}
        </div>
      </div>

      {links.map((link, index) => (
        <div
          key={index}
          className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-[14px] items-center"
        >
          {/* Social Media Platform Dropdown */}
          <div>
            <label className="block common-label pb-2">{field}</label>
            <Select
              value={link.platform}
              onChange={(value) => handleChange(index, "platform", value)}
              className="w-full h-[40px]"
              placeholder={`Select ${title}`}
              optionFilterProp="label" // Filters based on label
              showSearch
              filterOption={(input, option) =>
                option?.value?.toString().toLowerCase().includes(input.toLowerCase()) ?? false
              }
              options={socialPlatforms?.filter((o) => !marketplacePlatforms.includes(o?.value) || link.platform === o?.value)?.map((platform) => ({
                value: platform.value,
                label: (
                  <div className="flex items-center gap-2">
                    <span>{platform.icon ?? commonIcon}</span>
                    <span>{platform.label}</span>
                  </div>
                ),
              }))}
            />
          </div>

          {/* URL Input Field */}
          <div>
            <CommonInputField
              label="URL"
              //   placeholder="https://www.example.com"
              value={link.url}
              onChange={(e) => handleChange(index, "url", e.target.value)}
            />
          </div>

          {/* Delete Button with Proper Spacing */}
          <div className="flex justify-center items-center mt-6 ml-[14px]">
            <Button
              icon={<DeleteIcon />}
              onClick={() => handleDelete(index)}
              className=" p-[5px] hover:border hover:border-gray-100"
              type="text"
            /> </div>
        </div>
      ))}

      {/* Add New Button */}
      <NavigationButton
        type="text"
        icon={<PlusOutlined />}
        onClick={addNewLink}
        label="Add New"
      />
    </div>
  );
};

export default MultipleInputComponent;
